module.exports = {
  defaultLocale: 'en',
  locales: ['en', 'tc', 'ko'],
  prerender: true,
  analytics: {
    gtag: '',
    gtmId: 'GTM-TL6M298',
    optimizeId: '',
    hotjarId: '',
  },
  seo: {
    title: 'Riviera',
  },
  recaptcha: '6Lf40SccAAAAAP0rZ0TMD5kU3qSsQIJw7g6Glfns',
  stage: {
    mobile: 320,
    tablet: 768,
    desktop: 1440,
  },
  mediaQuery: {
    tablet: 576,
    desktop: 992,
  },
};
